import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Organization } from 'types'

type EntityType = 'organization' | 'deal' | 'product' // adjust as needed

export const getEntitiesByType = async (types: EntityType[]): Promise<Organization[]> => {
  const joined = types.join(',')
  const url = `${baseUrl}/aws/organizations_table/by-entity-type?types=${encodeURIComponent(joined)}`

  const response = await axios.get<Organization[]>(url)
  return response.data
}

export const useEntitiesByType = (types: EntityType[]): UseQueryResult<Organization[]> => {
  // Sort types alphabetically so keys stay stable for same set of types
  const sortedTypes = [...types].sort()

  // If single type, use specific key
  const queryKey = types.length === 1 ? ['entitiesByType', types[0]] : ['entitiesByType', sortedTypes]

  return useQuery({
    queryKey,
    queryFn: () => getEntitiesByType(types),
    enabled: types.length > 0,
  })
}
